import { useStaticQuery, graphql } from "gatsby"

export const useInsightsQuery = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpPost(
        filter: {
          categories: { nodes: { elemMatch: { name: { eq: "Insights" } } } }
        }
      ) {
        edges {
          node {
            id
            title
            uri
            excerpt
            content
            featuredImage {
              node {
                gatsbyImage(width: 300)
              }
            }
            tags {
              nodes {
                name
              }
            }
          }
        }
      }
    }
  `)
  return data
}
